import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class DataQualityFeatureService {
    private _router = inject(Router);

    goToFeature() {
        this._router.navigate(['/', 'data-health']);
    }

    goToQuality() {
        this._router.navigate(['/', 'data-health', 'quality']);
    }

    goToCompleteness() {
        this._router.navigate(['/', 'data-health', 'completeness']);
    }
}
